import { Navigate, generatePath } from "react-router";

import { PATHS } from "@/routes/paths";

import { NewDummyRoomEditPresenter } from "./presenter";
import { useDummyRoomEditQuery } from "../../model/repository/new";

type Props = {
	hotelID: string;
	roomID: string | undefined;
};

export const NewDummyRoomEditContainer = ({ hotelID, roomID }: Props) => {
	const serverModel = useDummyRoomEditQuery({ hotelID, roomID });

	if (!serverModel) {
		return <Navigate to={generatePath(PATHS.HOTEL.ITEMS.ROOM.TOP, { hotelID })} />;
	}

	return <NewDummyRoomEditPresenter hotelID={hotelID} serverModel={serverModel} />;
};

NewDummyRoomEditContainer.displayName = "NewDummyRoomEditContainer";
